import { render, staticRenderFns } from "./HotelFacility.vue?vue&type=template&id=f7ebbef0"
import script from "./HotelFacility.vue?vue&type=script&lang=js"
export * from "./HotelFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports